import React, { useEffect } from "react"
import { FaTimes } from "react-icons/fa"
import clsx from "clsx"

import { moment } from "utils"
import classes from "./DpYears.module.scss"

const DpYears = props => {
  const {
    minDate,
    maxDate,
    shownDate,
    setShownDate,
    setContent
  } = props

  const handleClick = year => {
    const newDate = moment(shownDate)
    newDate.jYear(year)

    setShownDate(newDate)
    setContent("months")
  }

  const handleClose = () => {
    setContent("days")
  }

  const years = []
  for (let i = 1500; i >= 1300; i--) years.push(i)

  useEffect(() => {
    const element = document.getElementById("active-year")
    element.scrollIntoView()
  }, [])

  return (
    <div className={classes["container"]}>
      <div className={classes["years"]}>
        <button
          onClick={handleClose}
          className={classes["close-button"]}
        >
          <FaTimes />
        </button>
        <div className={classes["years-container"]}>
          {years.map(year => {
            const isActive = shownDate.jYear() === year

            const isDisabled =
              (!!maxDate && year > moment(maxDate).jYear()) ||
              (!!minDate && year < moment(minDate).jYear())

            return (
              <button
                key={year}
                disabled={isDisabled}
                id={isActive ? "active-year" : ""}
                onClick={() => handleClick(year)}
                className={clsx(classes["year"],
                  isActive && classes["active"]
                )}
              >
                {year}
              </button>
            )
          })}
        </div>
      </div>
    </div>
  )
}

export default DpYears